import type { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  center?: boolean;
  children: ReactNode;
  variant?:
    | 'secondary'
    | 'primary'
    | 'success'
    | 'danger'
    | 'transparent'
    | 'gray'
    | 'outline';
}

const baseClasses =
  'flex items-center justify-center gap-2 rounded-2xl px-5 py-2.5 text-center text-sm font-medium text-white outline-none transition-all duration-200 shrink-0 hover:-translate-y-0.5 hover:opacity-100 focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2 disabled:hover:translate-y-0';
export const disabledClasses =
  'cursor-not-allowed opacity-70 hover:opacity-70 focus-visible:ring-0';

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'secondary',
  center = false,
  disabled,
  className,
  ...props
}) => (
  <button
    className={twMerge(
      baseClasses,
      clsx({
        'mx-auto': center,
        'bg-secondary shadow-[0_20px_35px_-20px_rgba(0,69,255,0.85)]':
          variant === 'secondary',
        'bg-gradient-to-r from-primary to-primary-500 shadow-[0_20px_35px_-20px_rgba(255,120,195,0.95)]':
          variant === 'primary',
        'bg-green-500 shadow-[0_20px_35px_-20px_rgba(34,197,94,0.9)]':
          variant === 'success',
        'bg-red shadow-[0_20px_35px_-20px_rgba(239,70,70,0.85)]':
          variant === 'danger',
        'border border-black/10 bg-[#f4f4f6] text-black shadow-[inset_0_1px_0_rgba(255,255,255,0.7)] hover:bg-white':
          variant === 'gray',
        'bg-transparent text-black shadow-none hover:bg-black/5':
          variant === 'transparent',
        'border border-black/10 bg-transparent text-black shadow-none hover:bg-black/5':
          variant === 'outline'
      }),
      disabled && disabledClasses,
      className
    )}
    disabled={disabled}
    {...props}>
    {children}
  </button>
);
